import React from "react";
import { Form, Button } from "react-bootstrap";
import { validateCoupon } from "../../helper";
import { TiDelete } from "react-icons/ti";
import strings from "../../constants/strings";
import "./styles.scss";

export default function CouponSelector(props) {
  const {
    coupon,
    setCoupon,
    validCoupon,
    setValidCoupon,
    showAlert,
    setShowLoadingModal,
    isMobile,
  } = props;
  return (
    <div className="d-flex justify-content-around coupon">
      <Form.Group className="m-0 d-flex justify-content-around">
        <Form.Control
          style={{ height: "2.5rem", width: isMobile ? "45%" : "65%" }}
          className="align-self-center mr-1"
          type="text"
          placeholder="Enter Coupon"
          value={coupon || ""}
          onChange={(event) => setCoupon(event.target.value)}
        />
        {validCoupon ? (
          <TiDelete
            className="align-self-center"
            size={50}
            onClick={() => {
              setValidCoupon(null);
              setCoupon(null);
            }}
          />
        ) : (
          <Button
            variant="outline-warning"
            className="landing-button align-self-center"
            onClick={async (event) => {
              event.preventDefault();
              setShowLoadingModal(true);
              validateCoupon(coupon)
                .then((result) => setValidCoupon(result))
                .then(() => {
                  setShowLoadingModal(false);
                  showAlert(
                    "Valid Coupon",
                    "Coupon has been applied. Your orders will be confirmed in cash.",
                    true
                  );
                })
                .catch(() => {
                  setShowLoadingModal(false);
                  showAlert(
                    strings.INVALID_COUPON,
                    "The coupon you entered is invalid."
                  );
                });
            }}
          >
            Apply
          </Button>
        )}
        {validCoupon !== null && (
          <p className="align-self-center text-uppercase">
            {validCoupon && (
              <span className="ml-1">{strings.VALID_COUPON}</span>
            )}
          </p>
        )}
      </Form.Group>
    </div>
  );
}
